// Single source of truth for community route paths.
export const COMMUNITY_JOIN_STAMPIN_UP = '/community/join-stampin-up' as const
export const COMMUNITY_STAMPIN_REWARDS = '/community/stampin-rewards' as const
